// extracted by mini-css-extract-plugin
export default {"main":"legal_main__LPkQs","body":"legal_body__2YC2s"};